<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-data-grid
            id="binsGrid"
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [allowColumnReordering]="true"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="false"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'bins-grid-state', savingTimeout: 0 }"
            (onRowDblClick)="onRowDblClick($event)"
            (onExporting)="onExporting($event)"
            [customizeColumns]="customizeColumns"
            keyExpr="number"
            width="100%"
        >
            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager
                [visible]="true"
                [displayMode]="'full'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true"
            >
            </dxo-pager>

            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
            <dxo-search-panel
                [visible]="true"
                placeholder="Search"
            ></dxo-search-panel>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
            <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
                <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
                <dxo-search [enabled]="true"></dxo-search>
                <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
            </dxo-column-chooser>

            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">Bins</div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{ text: 'Reset', icon: 'restore', onClick: resetGrid, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
                <dxi-item name="exportButton"></dxi-item>
            </dxo-toolbar>

            <dxi-column [dataField]="gridFieldName('number')" caption="Bin ID" [minWidth]="120" cellTemplate="numberTemplate" [sortOrder]="'asc'"></dxi-column>
            <dxi-column [dataField]="gridFieldName('storageType')" caption="Type" [lookup]="{ dataSource: binTypeOptions, valueExpr: 'value', displayExpr: 'text' }" [minWidth]="150"></dxi-column>
            <dxi-column [dataField]="gridFieldName('storageTypeCode')" caption="Storage Type" [minWidth]="150"></dxi-column>
            <dxi-column [dataField]="gridFieldName('storageBinType')" caption="Storage Bin Type" [minWidth]="150"></dxi-column>
            <dxi-column [dataField]="gridFieldName('maxPallets')" caption="Max Pallets" dataType="number" selectedFilterOperation=">=" [minWidth]="120" [alignment]="'left'"></dxi-column>
            <dxi-column [dataField]="gridFieldName('aisle')" caption="Aisle" [minWidth]="100"></dxi-column>
            <dxi-column [dataField]="gridFieldName('zone')" caption="Zone" [minWidth]="100"></dxi-column>

            <div *dxTemplate="let cellInfo of 'numberTemplate'">
                <div class="text-primary fw-semibold">
                    <a [routerLink]="`/inventory/storage-bins/details/${getCellData(cellInfo).number}`"
                       class="text-decoration-none">{{ getCellData(cellInfo).number }}</a>
                </div>
            </div>
        </dx-data-grid>
    </div>
    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item
                [dataField]="filterModelName('number')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'ID', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('storageType')"
                editorType="dxSelectBox"
                [editorOptions]="{ items: binTypeOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Type', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('storageTypeCode')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Storage Type', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('storageBinType')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Storage Bin Type', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('maxPallets')"
                editorType="dxNumberBox"
                [editorOptions]="{ placeholder: 'Max Pallets', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('aisle')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Aisle', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('zone')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Zone', stylingMode: 'filled' }"
            ></dxi-item>
        </dx-form>
    </filter-panel>
</div>

